module.exports = __webpack_public_path__ + "media/videoTour.808310a4.mp4";